import { useHasJobsAccess } from "domains/hire/hooks/useHasJobsAccess";
import { useFeatureFlag } from "providers/LaunchDarkly";

/** Working interviews appear on the Schedule with the rest of the Jobs renav: the `jobs-in-main-menu` flag, for people who see Jobs. */
export const isScheduleInterviewsEnabled = (jobsInMainMenu: boolean, hasJobsAccess: boolean): boolean =>
  jobsInMainMenu && hasJobsAccess;

export const useScheduleInterviewsEnabled = (): boolean =>
  isScheduleInterviewsEnabled(useFeatureFlag("jobs-in-main-menu"), useHasJobsAccess());
